module.exports = __webpack_public_path__ + "img/1up.e6f0f486.png";